import { Vehicle, VehicleStatusType } from "@alba-cars/common-modules";

export const CONSIGNMENT_OWNERSHIP_TYPE = "CONSIGNMENT";

type OwnershipVehicle = Pick<Vehicle, "status" | "ownershipType">;

export const isReservedConsignment = (vehicle: OwnershipVehicle | null | undefined): boolean => {
  if (!vehicle) {
    return false;
  }

  return vehicle.status === VehicleStatusType.RESERVED && vehicle.ownershipType === CONSIGNMENT_OWNERSHIP_TYPE;
};
